import React from 'react';

import 'quill/dist/quill.snow.css';

import Editors from './editor.js';
const Basketball = () => {
	return (
	
			<Editors id={"Basketball"}/>
	
	);
};
export default Basketball;
